import { URL_PREFIXES } from './endpointConfig';

export const isBeta = () => {
  const url = window.location.href;

  if (url.includes(URL_PREFIXES.BETA_URL_PREFIX)) {
    return true;
  }
  return false;
};

export const isLocal = () => {
  const url = window.location.href;

  if (url.includes(URL_PREFIXES.LOCAL_URL_PREFIX)) {
    return true;
  }
  return false;
};

export const isGamma = () => {
  const url = window.location.href;

  if (url.includes(URL_PREFIXES.GAMMA_URL_PREFIX)) {
    return true;
  }
  return false;
};

export const isProd = () => {
  const url = window.location.href;

  if (url.includes(URL_PREFIXES.PROD_URL_PREFIX)) {
    return true;
  }
  return false;
};
